interface ErrorTranslationRule {
  pattern: RegExp;
  message: string;
}

const errorTranslationRules: ErrorTranslationRule[] = [
  // Email automation rule conflict
  {
    pattern:
      /Email automation rule already exists for this dealer and trigger/i,
    message:
      "An automation rule for this trigger already exists. Please delete the existing rule first or choose a different trigger.",
  },

  // Phone number validation
  {
    pattern: /PhoneNumber.*e164/i,
    message: "Please enter a valid phone number (e.g., 555-123-4567)",
  },

  // Email validation
  {
    pattern: /Email.*email/i,
    message: "Please enter a valid email address",
  },

  // Website URL validation
  {
    pattern: /WebsiteURL.*url/i,
    message:
      "Please enter a valid website URL (e.g., example.com or https://example.com)",
  },

  // Generic validation fallback
  {
    pattern: /Field validation.*failed/i,
    message: "Please check your input and try again",
  },
];

export const translateErrorMessage = (apiErrorMessage: string): string => {
  if (!apiErrorMessage) {
    return "An error occurred. Please try again.";
  }

  // Try to find a matching translation rule
  for (const rule of errorTranslationRules) {
    if (rule.pattern.test(apiErrorMessage)) {
      return rule.message;
    }
  }

  // If no specific rule matches, return a generic message
  return "Please check your input and try again.";
};

export const shouldTranslateError = (statusCode: number): boolean => {
  // Translate 4xx client errors (user input issues)
  return statusCode >= 400 && statusCode < 500;
};
